(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ketienda-digital"] && !Shopify.designMode) return;
  try {
    
function initDigital(root){if(root.dataset.ready)return;root.dataset.ready='1';let set='all',size='all';const search=root.querySelector('[data-search]'),cards=[...root.querySelectorAll('[data-card]')],setButtons=[...root.querySelectorAll('[data-set]')],sizeButtons=[...root.querySelectorAll('[data-size]')];const normalize=v=>v.normalize('NFD').replace(/[̀-ͯ]/g,'').toLowerCase();function update(){const query=normalize(search.value.trim());let count=0;cards.forEach(card=>{const show=(set==='all'||card.dataset.setId.includes('|'+set+'|'))&&(size==='all'||card.dataset.quantity===size)&&normalize(card.dataset.name+' '+card.dataset.quantity).includes(query);card.hidden=!show;if(show)count++});root.querySelector('[data-count]').textContent=count+' '+(count===1?'paquete':'paquetes');root.querySelector('[data-empty]').hidden=count!==0;setButtons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.set===set)));sizeButtons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.size===size)))}setButtons.forEach(b=>b.addEventListener('click',()=>{set=b.dataset.set;update()}));sizeButtons.forEach(b=>b.addEventListener('click',()=>{size=b.dataset.size;update()}));search.addEventListener('input',update);root.querySelector('[data-reset]').addEventListener('click',()=>{set='all';size='all';search.value='';update();search.focus()});update()}document.querySelectorAll('[data-digital]').forEach(initDigital);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-digital]').forEach(initDigital));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poketienda-cart-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pk-cart-recommendations')) {
    customElements.define('pk-cart-recommendations', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.version = 0;
        this.update = async event => {
          try {
            if (event.promise) await event.promise;
            if (!this.isConnected) return;
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.refresh(), 150);
          } catch {}
        };
        import('@shopify/events').then(({ StandardEvents }) => {
          if (this.isConnected) document.addEventListener(StandardEvents.cartLinesUpdate, this.update, { signal: this.controller.signal });
        }).catch(() => {});
        this.enrich();
      }
      disconnectedCallback() {
        this.controller.abort();
        this.request?.abort();
        clearTimeout(this.timer);
      }
      async refresh() {
        const version = ++this.version;
        this.request?.abort();
        this.request = new AbortController();
        try {
          const url = new URL(this.dataset.cartUrl, location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, { signal: this.request.signal, cache: 'no-store' });
          if (!response.ok) return;
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const next = doc.querySelector('pk-cart-recommendations');
          if (version !== this.version || !this.isConnected || !next) return;
          for (const selector of ['[data-seeds]', '[data-candidates]', '[data-excluded]']) this.querySelector(selector).replaceWith(next.querySelector(selector));
          this.enrich();
        } catch {}
      }
      async enrich() {
        const version = ++this.version;
        this.request?.abort();
        this.request = new AbortController();
        const seeds = [...this.querySelector('[data-seeds]').content.children];
        const excluded = new Set([...this.querySelector('[data-excluded]').content.children].map(node => node.dataset.productId));
        const pool = new Map();
        const words = value => new Set((value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').split(/[^a-z0-9]+/).filter(word => word.length > 2 && !['pokemon','tcg','the','and','con','para','ingles','english','japanese','japones','box','pack','booster','bundle','elite','trainer','collection','coleccion','caja','sobre'].includes(word)));
        const metadata = node => ({ type: node.dataset.productType?.toLowerCase(), tags: JSON.parse(node.dataset.tags || '[]').map(tag => tag.toLowerCase()), words: words(node.dataset.title) });
        const signals = seeds.map(metadata);
        const add = (node, native = 0) => {
          const id = node.dataset.productId;
          if (!id || excluded.has(id) || seeds.some(seed => seed.dataset.productId === id)) return;
          const data = metadata(node);
          const score = signals.reduce((best, signal) => Math.max(best, (data.type && data.type === signal.type ? 8 : 0) + data.tags.filter(tag => signal.tags.includes(tag)).length * 4 + [...data.words].filter(word => signal.words.has(word)).length * 6), 0) + native;
          if (!pool.has(id) || pool.get(id).score < score) pool.set(id, { node, score });
        };
        [...this.querySelector('[data-candidates]').content.children].forEach(node => add(node));
        const render = () => {
          if (version !== this.version || !this.isConnected) return;
          const cards = [...pool.values()].sort((a,b) => b.score - a.score).slice(0,4).map(item => item.node.cloneNode(true));
          const grid = this.querySelector('.pk-cr-grid');
          if (grid.contains(document.activeElement)) return;
          grid.replaceChildren(...cards);
          this.hidden = cards.length === 0;
          this.dataset.recommendationState = seeds.length ? 'related' : 'fallback';
        };
        render();
        await Promise.allSettled(seeds.slice(0,3).map(async seed => {
          const url = new URL(this.dataset.recommendationsUrl, location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          url.searchParams.set('product_id', seed.dataset.productId);
          url.searchParams.set('limit','10');
          url.searchParams.set('intent','related');
          const response = await fetch(url, { signal: this.request.signal });
          if (!response.ok) return;
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          [...(doc.querySelector('[data-candidates]')?.content.children || [])].forEach((node,index) => add(node, 12 - index));
        }));
        render();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poketienda-digital-detail-preview"]) return;
  try {
    function initDigitalDetail(){const handle=new URLSearchParams(location.search).get('pack')||'codigos-151-25';let found=false;document.querySelectorAll('[data-pack]').forEach(p=>{p.hidden=p.dataset.pack!==handle;if(!p.hidden)found=true});document.querySelector('[data-missing]').hidden=found;}initDigitalDetail();document.addEventListener('shopify:section:load',initDigitalDetail);document.addEventListener('click',e=>{const b=e.target.closest('[data-preview-add]');if(!b)return;const m=document.querySelector('[data-preview-message]');m.hidden=false;m.textContent='Vista de revisión: '+b.dataset.previewAdd+'. La compra se habilitará al publicar los productos.';});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poketienda-digital-preview"]) return;
  try {
    
function initDigital(root){if(root.dataset.ready)return;root.dataset.ready='1';let set='all',size='all';const search=root.querySelector('[data-search]'),cards=[...root.querySelectorAll('[data-card]')],setButtons=[...root.querySelectorAll('[data-set]')],sizeButtons=[...root.querySelectorAll('[data-size]')];const normalize=v=>v.normalize('NFD').replace(/[̀-ͯ]/g,'').toLowerCase();function update(){const query=normalize(search.value.trim());let count=0;cards.forEach(card=>{const show=(set==='all'||card.dataset.setId.includes('|'+set+'|'))&&(size==='all'||card.dataset.quantity===size)&&normalize(card.dataset.name+' '+card.dataset.quantity).includes(query);card.hidden=!show;if(show)count++});root.querySelector('[data-count]').textContent=count+' '+(count===1?'paquete':'paquetes');root.querySelector('[data-empty]').hidden=count!==0;setButtons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.set===set)));sizeButtons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.size===size)))}setButtons.forEach(b=>b.addEventListener('click',()=>{set=b.dataset.set;update()}));sizeButtons.forEach(b=>b.addEventListener('click',()=>{size=b.dataset.size;update()}));search.addEventListener('input',update);root.querySelector('[data-reset]').addEventListener('click',()=>{set='all';size='all';search.value='';update();search.focus()});update()}document.querySelectorAll('[data-digital]').forEach(initDigital);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-digital]').forEach(initDigital));
document.addEventListener('click',e=>{const b=e.target.closest('[data-preview-add]');if(!b)return;const m=document.querySelector('[data-preview-message]');m.hidden=false;m.textContent='Vista de revisión: '+b.dataset.previewAdd+'. La compra se habilitará al publicar los productos.';});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poketienda-header"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-pk-header]').forEach((header)=>{const details=header.querySelector('[data-pk-search-details]');const input=header.querySelector('[data-pk-search-input]');const results=header.querySelector('[data-pk-predictive]');if(!details||!input||!results)return;let timer;details.addEventListener('toggle',()=>{if(details.open)setTimeout(()=>input.focus(),30)});input.addEventListener('input',()=>{clearTimeout(timer);const term=input.value.trim();input.setAttribute('aria-expanded',term.length>0?'true':'false');if(term.length<2){results.innerHTML='';return}timer=setTimeout(async()=>{try{const url=new URL(header.dataset.predictiveUrl,window.location.origin);url.searchParams.set('q',term);url.searchParams.set('resources[type]','product,collection');url.searchParams.set('resources[limit]','6');url.searchParams.set('section_id','poketienda-predictive-search');const response=await fetch(url);if(!response.ok)throw new Error();results.innerHTML=await response.text()}catch(error){results.innerHTML=''}},220)});document.addEventListener('click',(event)=>{if(details.open&&!details.contains(event.target))details.removeAttribute('open')})});document.querySelectorAll('[data-pk-smart-prompt]').forEach((prompt)=>{const key=prompt.dataset.storageKey;let dismissed=0;try{dismissed=Number(localStorage.getItem(key)||0)}catch(error){}if(!dismissed||Date.now()-dismissed>2592000000)prompt.hidden=false;prompt.querySelector('[data-pk-prompt-close]')?.addEventListener('click',()=>{prompt.hidden=true;try{localStorage.setItem(key,String(Date.now()))}catch(error){}})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poketienda-home"] && !Shopify.designMode) return;
  try {
    
function initPoketiendaCarousels(root) {
  root.querySelectorAll('[data-pk-carousel]').forEach((carousel) => {
    if (carousel.dataset.initialized) return;
    carousel.dataset.initialized = 'true';
    const slides = [...carousel.querySelectorAll('[data-pk-slide]')];
    const dots = [...carousel.querySelectorAll('[data-pk-dot]')];
    const show = (index) => {
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.inert = i !== index;
        slide.setAttribute('aria-hidden', String(i !== index));
      });
      dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };
    dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
    show(0);
  });
}
initPoketiendaCarousels(document);
document.addEventListener('shopify:section:load', (event) => initPoketiendaCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poketienda-product-detail"]) return;
  try {
    
document.querySelectorAll('[data-pk-product]').forEach((product)=>{const carousel=product.querySelector('[data-pk-carousel]');if(!carousel)return;const slides=[...carousel.querySelectorAll('[data-pk-slide]')];const thumbs=[...product.querySelectorAll('[data-pk-thumb]')];const current=carousel.querySelector('[data-pk-current]');let active=0;const show=(next)=>{if(!slides.length)return;active=(next+slides.length)%slides.length;slides.forEach((slide,index)=>{slide.hidden=index!==active;slide.classList.toggle('is-active',index===active)});thumbs.forEach((thumb,index)=>{thumb.classList.toggle('is-active',index===active);thumb.setAttribute('aria-current',index===active?'true':'false')});if(current)current.textContent=active+1};carousel.querySelector('[data-pk-prev]')?.addEventListener('click',()=>show(active-1));carousel.querySelector('[data-pk-next]')?.addEventListener('click',()=>show(active+1));thumbs.forEach((thumb,index)=>thumb.addEventListener('click',()=>show(index)));carousel.addEventListener('keydown',(event)=>{if(event.key==='ArrowLeft')show(active-1);if(event.key==='ArrowRight')show(active+1)});let startX=0;carousel.addEventListener('touchstart',(event)=>{startX=event.changedTouches[0].clientX},{passive:true});carousel.addEventListener('touchend',(event)=>{const distance=event.changedTouches[0].clientX-startX;if(Math.abs(distance)>45)show(active+(distance<0?1:-1))},{passive:true});show(0)});
document.querySelectorAll('.pk-product__gallery,.pk-single-detail__media').forEach((gallery)=>{gallery.querySelectorAll('img').forEach((image)=>image.setAttribute('draggable','false'));gallery.addEventListener('contextmenu',(event)=>{if(event.target.closest('img'))event.preventDefault()})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poketienda-products-catalog"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-pk-store]').forEach((store)=>{const cards=[...store.querySelectorAll('[data-pk-store-card]')];const search=store.querySelector('[data-pk-store-search]');const filters=store.querySelector('[data-pk-store-filters]');const count=store.querySelector('[data-pk-store-count]');const empty=store.querySelector('[data-pk-store-empty]');const sort=store.querySelector('[data-pk-store-sort]');let selected='all';const apply=()=>{const term=search.value.trim().toLowerCase();let visible=0;cards.forEach((card)=>{const text=card.dataset.title+' '+card.dataset.tags;const matchesFilter=selected==='all'||card.dataset.tags.includes(selected);const matchesSearch=!term||text.includes(term);const show=matchesFilter&&matchesSearch;card.hidden=!show;if(show)visible+=1});count.textContent=visible+' '+(visible===1?store.dataset.resultsOne:store.dataset.resultsMany);if(empty)empty.hidden=visible!==0};filters.addEventListener('click',(event)=>{const button=event.target.closest('[data-filter]');if(!button)return;selected=button.dataset.filter;filters.querySelectorAll('[data-filter]').forEach((item)=>item.classList.toggle('is-active',item===button));apply()});search.addEventListener('input',apply);if(sort)sort.addEventListener('change',()=>{const url=new URL(window.location.href);url.searchParams.set('sort_by',sort.value);window.location.assign(url.toString())});apply()});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poketienda-secret-packs"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-pk-packs]').forEach((page)=>{const cards=[...page.querySelectorAll('[data-pk-pack]')];const filters=page.querySelector('[data-pk-pack-filters]');const empty=page.querySelector('[data-pk-pack-empty]');filters?.addEventListener('click',(event)=>{const button=event.target.closest('[data-size]');if(!button)return;const size=button.dataset.size;filters.querySelectorAll('[data-size]').forEach((item)=>item.classList.toggle('is-active',item===button));let visible=0;cards.forEach((card)=>{const show=size==='all'||card.dataset.size===size;card.hidden=!show;if(show)visible+=1});if(empty)empty.hidden=visible!==0})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poketienda-singles-catalog"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-pk-singles-catalog]').forEach(async (catalog) => {
  if (catalog.dataset.initialized) return;
  catalog.dataset.initialized = 'true';
  const grid = catalog.querySelector('[data-pk-card-grid]');
  const setsGrid = catalog.querySelector('[data-pk-set-grid]');
  const search = catalog.querySelector('[data-pk-search]');
  const languages = catalog.querySelector('[data-pk-language-filters]');
  const count = catalog.querySelector('[data-pk-results-count]');
  const empty = catalog.querySelector('[data-pk-empty]');
  const pager = catalog.querySelector('[data-pk-pages]');
  const fallback = catalog.querySelector('.pk-pagination');
  const status = catalog.querySelector('[data-pk-load-status]');
  const retry = catalog.querySelector('[data-pk-retry]');
  const text = JSON.parse(catalog.querySelector('[data-pk-text]').textContent);
  const aliases = {'fuegos-fantasmales':'phantasmal-flames','promos-escarlata-y-purpura':'scarlet-violet-black-star-promos','aventuras-compartidas':'journey-together','evoluciones-en-paldea':'paldea-evolved'};
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  const slug = value => normalize(value).replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
  const keyFor = value => aliases[slug(value)] || slug(value);
  const languageFor = value => ({ja:'jp','zh-cn':'cn',ko:'kr'}[value] || value);
  const urlState = () => new URL(window.location.href).searchParams;
  let selectedSet = urlState().get('set') || 'all';
  let selectedLanguage = urlState().get('lang') || 'all';
  let page = Math.max(1, Number.parseInt(urlState().get('p') || '1',10) || 1);
  search.value = urlState().get('q') || '';
  let cards = [];
  let sets = new Map();
  const images = JSON.parse(catalog.querySelector('[data-pk-images]').textContent);
  images['pitch-black']=catalog.dataset.pitchBlackImage||'';
  const labelCount = n => n+' '+(n===1?catalog.dataset.countOne:catalog.dataset.countMany);
  const element = (tag, cls, value) => {
    const node=document.createElement(tag);
    if(cls)node.className=cls;
    if(value!==undefined)node.textContent=value;
    return node;
  };
  const syncUrl = () => {
    const url=new URL(window.location.href);
    url.searchParams.delete('page');
    for(const [key,value] of [['set',selectedSet],['lang',selectedLanguage],['q',search.value.trim()],['p',String(page)]]) {
      if(value==='all'||value===''||(key==='p'&&value==='1'))url.searchParams.delete(key);
      else url.searchParams.set(key,value);
    }
    window.history.replaceState(null,'',url);
  };
  const makeCard = card => {
    const article=element('article','pk-single-card');
    article.dataset.pkCard=''; article.dataset.id=card.id;
    const link=element('a');link.href=card.url;
    const media=element('div','pk-single-card__media');
    if(card.image){const img=element('img');img.src=card.image;img.alt=card.title;img.loading='lazy';img.width=360;img.height=504;media.append(img);}
    const body=element('div','pk-single-card__body');
    const badges=element('div','pk-badges');
    [card.language.toUpperCase(),card.condition,card.rarity].filter(Boolean).forEach(v=>badges.append(element('span','',v)));
    body.append(badges,element('h3','',card.title),element('p','',card.set),element('strong','',card.price));
    link.append(media,body);article.append(link);
    const form=element('form','pk-single-card__add-form');
    form.method='post';form.action=catalog.dataset.cartAddUrl;
    for(const [name,value] of [['id',String(card.variantId)],['quantity','1'],['return_to',catalog.dataset.cartAddUrl.replace(/add$/,'')]]) {
      const input=element('input');input.type='hidden';input.name=name;input.value=value;form.append(input);
    }
    const add=element('button','pk-single-card__add');add.type='submit';
    add.setAttribute('aria-label',catalog.dataset.addLabel+': '+card.title);add.title=catalog.dataset.addLabel;
    const icon=element('span','','+');icon.setAttribute('aria-hidden','true');add.append(icon);
    form.append(add);article.append(form);return article;
  };
  const render = () => {
    const term=normalize(search.value.trim());
    const searched=cards.filter(card=>!term||card.search.includes(term));
    const inSet=searched.filter(card=>selectedSet==='all'||card.key===selectedSet);
    if(selectedLanguage!=='all'&&!inSet.some(card=>card.language===selectedLanguage))selectedLanguage='all';
    const eligible=searched.filter(card=>selectedLanguage==='all'||card.language===selectedLanguage);
    sets.forEach((value,key)=>{
      const matches=eligible.filter(card=>card.key===key);
      value.button.hidden=matches.length===0;
      const representation=matches.find(card=>card.language===selectedLanguage)||matches.find(card=>card.language==='es')||matches[0];
      if(representation){
        value.title.textContent=representation.set;
        const image=images[slug(representation.set)];
        value.art.replaceChildren();
        if(image){const img=element('img');img.src=image;img.alt='';img.loading='lazy';value.art.append(img);}else value.art.textContent='◇';
      }
      value.count.textContent=labelCount(matches.length)+' · '+[...new Set(matches.map(card=>card.language.toUpperCase()))].sort().join(' / ');
    });
    const matches=eligible.filter(card=>selectedSet==='all'||card.key===selectedSet);
    const totalPages=Math.ceil(matches.length/20);
    page=Math.min(page,Math.max(1,totalPages));
    grid.replaceChildren(...matches.slice((page-1)*20,page*20).map(makeCard));
    setsGrid.querySelectorAll('[data-set]').forEach(button=>{
      button.classList.toggle('is-active',button.dataset.set===selectedSet);
      button.setAttribute('aria-pressed',String(button.dataset.set===selectedSet));
    });
    languages.querySelectorAll('[data-language]').forEach(button=>{
      button.hidden=button.dataset.language!=='all'&&!inSet.some(card=>card.language===button.dataset.language);
      button.classList.toggle('is-active',button.dataset.language===selectedLanguage);
      button.setAttribute('aria-pressed',String(button.dataset.language===selectedLanguage));
    });
    count.textContent=labelCount(matches.length);
    catalog.querySelector('[data-pk-all-count]').textContent=labelCount(eligible.length);
    empty.hidden=matches.length!==0;
    pager.replaceChildren();pager.hidden=totalPages<2;
    const addPage=(n,label)=>{const b=element('button','',label||String(n));b.type='button';b.dataset.page=n;b.setAttribute('aria-label',text.page+' '+n);if(n===page)b.setAttribute('aria-current','page');pager.append(b);};
    if(page>1)addPage(page-1,'←');
    const pages=new Set([1,totalPages]);
    for(let n=Math.max(1,page-2);n<=Math.min(totalPages,page+2);n++)pages.add(n);
    let last=0;
    [...pages].filter(n=>n>0).sort((a,b)=>a-b).forEach(n=>{if(last&&n-last>1)pager.append(element('span','','…'));addPage(n);last=n;});
    if(page<totalPages)addPage(page+1,'→');
    syncUrl();
  };
  const load = async () => {
    status.textContent=text.loading;retry.hidden=true;
    search.disabled=true;languages.querySelectorAll('button').forEach(b=>b.disabled=true);
    try {
      const collected=[];const seen=new Set();let next=1;
      while(next){
        const url=new URL(catalog.dataset.collectionUrl,window.location.origin);
        const preview=urlState().get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
        url.searchParams.set('section_id','poketienda-singles-index');url.searchParams.set('page',String(next));
        const response=await fetch(url,{signal:AbortSignal.timeout(20000)});
        if(!response.ok)throw new Error('Index HTTP error');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const payload=doc.querySelector('[data-pk-index]');if(!payload)throw new Error('Missing index');
        const data=JSON.parse(payload.textContent);
        if(data.truncated)throw new Error('Index exceeds pagination limit');
        data.cards.filter(Boolean).forEach(card=>{if(!seen.has(card.id)){seen.add(card.id);collected.push(card);}});
        if(data.next&&data.next<=next)throw new Error('Invalid next page');
        next=data.next;
      }
      cards=collected.map(card=>({...card,key:keyFor(card.set),language:languageFor(card.language),search:normalize(card.title+' '+card.set+' '+card.tags)}));
      sets=new Map();setsGrid.querySelectorAll('[data-set]:not([data-set="all"])').forEach(b=>b.remove());
      cards.forEach(card=>{
        if(!card.set||sets.has(card.key))return;
        const button=element('button','pk-set-card');button.type='button';button.dataset.set=card.key;
        const art=element('span','pk-set-card__art');art.setAttribute('aria-hidden','true');
        const details=element('span'),title=element('strong'),count=element('small');details.append(title,count);button.append(art,details);
        setsGrid.append(button);sets.set(card.key,{button,art,title,count});
      });
      if(selectedSet!=='all'&&!sets.has(selectedSet))selectedSet='all';
      if(fallback)fallback.hidden=true;
      status.textContent='';search.disabled=false;languages.querySelectorAll('button').forEach(b=>b.disabled=false);
      render();
    }catch(error){
      status.textContent=text.failed;retry.hidden=false;
      if(fallback)fallback.hidden=false;
    }
  };
  setsGrid.addEventListener('click',event=>{const b=event.target.closest('[data-set]');if(!b||b.hidden||search.disabled)return;selectedSet=b.dataset.set;selectedLanguage='all';page=1;render();});
  languages.addEventListener('click',event=>{const b=event.target.closest('[data-language]');if(!b||b.hidden||b.disabled)return;selectedLanguage=b.dataset.language;page=1;render();});
  search.addEventListener('input',()=>{page=1;render();});
  pager.addEventListener('click',event=>{const b=event.target.closest('[data-page]');if(!b)return;page=Number(b.dataset.page);render();catalog.querySelector('.pk-card-results').scrollIntoView({block:'start'});});
  retry.addEventListener('click',load);
  await load();
});

  } catch(e) { console.error(e); }
})();
})();
